import React from 'react';
import { Collapse as BlueprintCollapse } from '@blueprintjs/core';

const Collapse = (props) => <BlueprintCollapse {...props} />;

export default Collapse;
